import { useEffect } from 'react';
import {
  useCreateReportMutation,
  useGetSiteStudyPersonnelsQuery,
  useUpdateReportMutation,
  useGetAllSQReportsMutation,
  usePublishSQReportEtmfMutation
} from 'src/services/SqReport';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useSqReport = () => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const dispatch = useAppDispatch();

  const [createSqReport, { data: createSqReportData, error: createSqReportError }] = useCreateReportMutation();
  const [updateSqReport, { data: updateSqReportData, error: updateSqReportError }] = useUpdateReportMutation();

  const {
    data: studySitePersonnelQueryData,
    error: getStudySitePersonnelError,
    refetch: getStudySitePersonnelQueryData
  } = useGetSiteStudyPersonnelsQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  useEffect(() => {
    if (createSqReportError || updateSqReportError || getStudySitePersonnelError) {
      updateUserAccess(createSqReportError || updateSqReportError || getStudySitePersonnelError, dispatch);
    }
  }, [createSqReportError, updateSqReportError, getStudySitePersonnelError]);

  const [
    getAllSQReports,
    {
      isLoading: getAllSqReportLoading,
      isError: getAllSqReportIsError,
      data: getAllSqReportData,
      error: getAllSqReportError
    }
  ] = useGetAllSQReportsMutation();

  const [
    publishSQReportEtmf,
    {
      isLoading: publishSQReportLoading,
      isSuccess: publishSQReportSuccess,
      data: publisSQReportData,
      isError: publishSQReportIsError,
      error: publishSQReportError
    }
  ] = usePublishSQReportEtmfMutation();

  return {
    createSqReport,
    createSqReportData,
    createSqReportError,
    updateSqReport,
    updateSqReportData,
    getStudySitePersonnelQueryData,
    studySitePersonnelQueryData,
    getAllSQReports,
    getAllSqReportData,
    getAllSqReportIsError,
    getAllSqReportLoading,
    getAllSqReportError,
    publishSQReportEtmf,
    publishSQReportLoading,
    publishSQReportSuccess,
    publisSQReportData,
    publishSQReportIsError,
    publishSQReportError
  };
};
